import { apiService } from './api';
import { ApiResponse } from '../types';

export interface BackupFile {
  filename: string;
  size: number;
  created_at: string;
  modified_at: string;
}

export const backupService = {
  async createBackup(): Promise<ApiResponse<{ filename: string; path: string; size: number; created_at: string }>> {
    return apiService.post('/api/backup/create', {});
  },

  async listBackups(): Promise<ApiResponse<BackupFile[]>> {
    return apiService.get('/api/backup/list');
  },

  async downloadBackup(filename: string): Promise<Blob> {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/backup/download/${filename}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to download backup');
    }
    return await response.blob();
  },

  async restoreBackup(filename: string): Promise<ApiResponse> {
    return apiService.post(`/api/backup/restore/${filename}`, {});
  },

  async deleteBackup(filename: string): Promise<ApiResponse> {
    return apiService.delete(`/api/backup/delete/${filename}`);
  },
};

